import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type HeaderProps = {
  isPending: boolean
}

type HAFieldProps = {
  width: string
}

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xm};
`
export const WrapperHeader = styled.div<HeaderProps>`
  width: 100%;
  display: flex;
  gap: ${theme.spacing.sm};
  flex-wrap: wrap;
  align-items: center;
`

export const TableWrapper = styled.div`
  display: grid;
`

export const HeaderActions = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};

  @media (max-width: ${theme.breakpoints.lg}px) {
    width: 100%;

    .insertMaterial {
      flex: 1;
    }
  }
`

export const HeaderActionsField = styled.div<HAFieldProps>`
  width: ${({ width }) => width};
`

export const Title = styled.h5`
  margin: 0;
  font-family: ${theme.typography.family.bold};
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes['2md']};
  font-weight: ${theme.typography.weight.lg};
  padding-right: ${theme.spacing.lg};
`

export const EmptySize = styled.div`
  opacity: 0.2;
`

export const SummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap-reverse;
  gap: ${theme.spacing.xm};
  justify-content: space-between;
`

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.lg};

  @media (max-width: ${theme.breakpoints.lg}px) {
    width: 100%;
  }
`

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.xm};
`

export const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`

export const StrategyText = styled.span`
  color: ${theme.colors.alert.success.dark};
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};
`
